import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=72bf7ef8&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=ts"
export * from "./jobDetail.vue?vue&type=script&lang=ts"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=72bf7ef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf7ef8",
  null
  
)

export default component.exports